import { type UncefactUnitType } from '~/types/unit';

import { useUnitOptions } from '~/data/unit';

import { sortByKey } from '@vestigas/utils';
import { i18n } from '~/utils';

const MOST_IMPORTANT_UNITS: readonly UncefactUnitType[] = [
  'EA',
  'TNE',
  'KGM',
  'MTQ',
];

const OTHER_UNITS: readonly UncefactUnitType[] = [
  'MTR',
  'MTK',
  'SA',
  'RO',
  'PF',
  'PA',
  'BJ',
  'BG',
  'PK',
  'TU',
  'CA',
  'CI',
  'PR',
  'CT',
  'E48',
  'LTR',
  'HUR',
  'MIN',
];

export const useDashboardUnits = () => {
  const units =
    useUnitOptions({
      label: 'fullName',
      language: 'DE',
    }) ?? [];

  return [
    {
      label: i18n.t('mostImportantUnits.label', { ns: 'units' }),
      options: [
        {
          value: '',
          label: i18n.t('allUnits.label', { ns: 'units' }),
        },
        ...units.filter(({ value }) => MOST_IMPORTANT_UNITS.includes(value)),
      ],
    },
    {
      label: i18n.t('otherUnits.label', { ns: 'units' }),
      options: sortByKey(
        units.filter(({ value }) => OTHER_UNITS.includes(value)),
        'label',
      ),
    },
  ];
};
